import gql from 'graphql-tag';
import PaginatorInfoFragment from '../fragments/PaginatorInfoFragment';
import UserListItemFragment from '../fragments/UserListItemFragment';

export default gql`
query userList($filters: UserFilters, $sortBy: UserSort, $count: Int!, $page: Int) {
    listUsers(filters: $filters, sortBy: $sortBy, first: $count, page: $page) {
        paginatorInfo {
            ...PaginatorInfoFragment
        }
        data {
            ...UserListItemFragment
        }
    }
}
${PaginatorInfoFragment}
${UserListItemFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/userList.ts